import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Popconfirm,Popover,
  Collapse,Avatar,Drawer,Descriptions,message,Modal,Spin,Switch} from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,FundOutlined,FundViewOutlined,DeleteOutlined,LockFilled,LockOutlined,LoadingOutlined } from '@ant-design/icons';
import { UserOutlined } from '@ant-design/icons';
import { Form,Select,Checkbox,Upload } from 'antd';
import { Link } from 'react-router-dom';
import * as serverconfig from '../../serverconn'
import UserCreationForm from '../components/UserCreationForm'

var CryptoJS = require("crypto-js");
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const { Panel } = Collapse;
const FormItem=Form.Item;

function callback(key) {
  console.log(key);
}

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var sacco= ''
var username=''
var token= ''
var ngoid= ''

class AccountList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    accounts: [],
    rightsmodalvisible:false,
    rights: {},
    selectedid:'',
    datarequested:true,

    can_view_dashboard:true,
    can_enter_doctor:true,
    can_view_doctors:true,

    can_enter_speciality:true,
    can_view_speciality:true,

    can_enter_patient:true,
    can_view_patients:true,

    can_enter_newcase:true,
    can_edit_case:true,
    can_view_allcases:true,

    can_create_patient_reviews:true,
    can_edit_patient_reviews:true,
    can_view_patient_reviews:true,
    
    can_assign_cases:true,
    can_create_case_review:true,
    can_view_case_reviews:true,

   
  };

  displaypasswordupdatemodal=(id)=>{
    this.setState({showpasswordupdatemodal:true})
    this.setState({selectedid:id})
  }
  
  closepasswordupdatemodal=()=>{
    this.setState({showpasswordupdatemodal:false})
  }
  
  //////////////////////////////////////
  ///// change password here
  handlePasswordChange=(values)=>{
    this.setState({datarequested:true})

    let form_data = new FormData();
    form_data.append('password1', values.new_password1);
    form_data.append('password2', values.new_password2);
    form_data.append('userid', this.state.selectedid);
  
    //Now send the post resquest
      axios.post(serverconfig.backendserverurl+'/customqueries/updatecompanyuserpassword', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
      this.setState({datarequested:false})

      message.info(res.data.message);
    }
    )
    .catch(error => console.log(error)) 
  
  }




  ///////////////////////////////////////////
  //getting simple user account rights
  showAccountRights=(text) =>{
    this.setState({ rightsmodalvisible: true });

    //make api call to get the user rights
    axios.get(`${serverconfig.backendserverurl}/api/accountrights?user=${text}`)
    .then(res => {  
        this.setState({
            rights: res.data[0]
        })
        this.setState({can_view_dashboard:res.data[0].can_view_dashboard})
        this.setState({can_enter_doctor:res.data[0].can_enter_doctor})
        this.setState({can_view_doctors:res.data[0].can_view_doctors})

        this.setState({can_enter_speciality:res.data[0].can_enter_speciality})
        this.setState({can_view_speciality:res.data[0].can_view_speciality})

        this.setState({can_enter_patient:res.data[0].can_enter_patient})
        this.setState({can_view_patients:res.data[0].can_view_patients})

        this.setState({can_enter_newcase:res.data[0].can_enter_newcase})
        this.setState({can_edit_case:res.data[0].can_edit_case})
        this.setState({can_view_allcases:res.data[0].can_view_allcases})

        this.setState({can_create_patient_reviews:res.data[0].can_create_patient_reviews})
        this.setState({can_edit_patient_reviews:res.data[0].can_edit_patient_reviews})
        this.setState({can_view_patient_reviews:res.data[0].can_view_patient_reviews})

        this.setState({can_assign_cases:res.data[0].can_assign_cases})
        this.setState({can_create_case_review:res.data[0].can_create_case_review})
        this.setState({can_view_case_reviews:res.data[0].can_view_case_reviews})



    })

  }

  //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    axios.delete(`${serverconfig.backendserverurl}/api/accounts/${id}`).then(res =>{
      window.location.reload(false)
      message.info("successfully deleted") 
     }
     );
  };


  //Item addition success
  onresetdrawerClose = () => {
    this.setState({ rightsmodalvisible: false });
  };


  //make an update now on the user rights
  updaterights=values=>{
    let form_data = new FormData();

    form_data.append('can_view_dashboard', this.state.can_view_dashboard)
    form_data.append('can_enter_doctor', this.state.can_enter_doctor)
    form_data.append('can_view_doctors', this.state.can_view_doctors)

    form_data.append('can_enter_speciality', this.state.can_enter_speciality)
    form_data.append('can_view_speciality', this.state.can_view_speciality)

    form_data.append('can_enter_patient', this.state.can_enter_patient)
    form_data.append('can_view_patients', this.state.can_view_patients)

    form_data.append('can_enter_newcase', this.state.can_enter_newcase)
    form_data.append('can_edit_case', this.state.can_edit_case)
    form_data.append('can_view_allcases', this.state.can_view_allcases)

    form_data.append('can_create_patient_reviews', this.state.can_create_patient_reviews)
    form_data.append('can_edit_patient_reviews', this.state.can_edit_patient_reviews)
    form_data.append('can_view_patient_reviews', this.state.can_view_patient_reviews)
    
    form_data.append('can_assign_cases', this.state.can_assign_cases)
    form_data.append('can_create_case_review', this.state.can_create_case_review)
    form_data.append('can_view_case_reviews', this.state.can_view_case_reviews)


    //Now send the post resquest
    axios.put(`${serverconfig.backendserverurl}/api/accountrights/${this.state.rights.id}/`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => window.location.reload(false)
    )
    .catch(error => console.log(error))

  }


  componentDidMount(){

    if(localStorage.getItem("sacco")){
      ngoid= CryptoJS.AES.decrypt(localStorage.getItem("ngoid") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
      ngoid= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/accounts/?Ngo=${ngoid}`)
    .then(res => {
        this.setState({
          accounts:res.data
        })

        this.setState({datarequested:false})

    })

}


  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const columns = [
      {
        title: 'Profile',
        dataIndex: 'profile_pic',
        key: 'profile_pic',
        render: (text,record) => <Avatar
        size={60}
        icon={<UserOutlined />}
        alt="User Pic"
        src={serverconfig.backendserverurl+`/customqueries/getfile/${Number(record.id)}/${'user_account'}`}
        />,

      },
      {
        title: 'User Name',
        dataIndex: 'username',
        key: 'username',
        ...this.getColumnSearchProps('username'),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        key: 'id',
        render: text =>
        <p>
        <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
         <Link to={`/useraccounts/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
        </Popover>
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to delete client</p>} title="Delete">
        <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
          <DeleteOutlined style={{color:'red'}}/>
         </Popconfirm>
        </Popover>
{ /*       &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click here to edit,view user rights</p>} title="Edit,View rights">
         <UserOutlined onClick={(event) => this.showAccountRights(text)} style={{color:'blue'}}/>
        </Popover > */}
        &nbsp;&nbsp;&nbsp;
        <Popover content={<p>Click to change password</p>} title="Password Change">
          <LockFilled style={{color:'#154360'}} onClick={() => this.displaypasswordupdatemodal(text)}/>
        </Popover>
        </p>,
      },

    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>       
        </div>
      )

    }else{

      return(
        <div>
           <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header="ALL ACCOUNTS" key="1">
            <Table 
             scroll={{ x: 1000 }}
             columns={columns}
             pagination={{showQuickJumper:true,showSizeChanger:true }}
             dataSource={this.state.accounts} bordered/>
            </Panel>
            </Collapse>
            <br></br>
            <UserCreationForm />
            <br></br>

            <Drawer
                title={this.state.rights.username+" "+"Account Rights"}
                width={520}
                placement="right"
                closable={false}
                onClose={this.onresetdrawerClose}
                visible={this.state.rightsmodalvisible}
              >
  

                    <h3 style={{color:'red'}}>Edit User Rights</h3>

                    <Form  
                      onFinish={this.updaterights}        
                      >
                      <FormItem name="can_view_dashboard" label="can_view_dashboard" >
                          <Switch
                              checked={this.state.can_view_dashboard}
                              onChange={(val)=>{this.setState({can_view_dashboard:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>  

                      <FormItem name="can_view_doctors" label="can_view_doctors" >
                          <Switch
                              checked={this.state.can_view_doctors}
                              onChange={(val)=>{this.setState({can_view_doctors:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="can_enter_doctor" label="can_enter_doctor" >
                          <Switch
                              checked={this.state.can_enter_doctor}
                              onChange={(val)=>{this.setState({can_enter_doctor:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 
                      

                      <FormItem name="can_enter_speciality" label="can_enter_speciality" >
                          <Switch
                              checked={this.state.can_enter_speciality}
                              onChange={(val)=>{this.setState({can_enter_speciality:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="can_view_speciality" label="can_view_speciality" >
                          <Switch
                              checked={this.state.can_view_speciality}
                              onChange={(val)=>{this.setState({can_view_speciality:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="can_enter_patient" label="can_enter_patient" >
                          <Switch
                              checked={this.state.can_enter_patient}
                              onChange={(val)=>{this.setState({can_enter_patient:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="can_view_patients" label="can_view_patients" >
                          <Switch
                              checked={this.state.can_view_patients}
                              onChange={(val)=>{this.setState({can_view_patients:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem> 

                      <FormItem name="can_enter_newcase" label="can_enter_newcase" >
                          <Switch
                              checked={this.state.can_enter_newcase}
                              onChange={(val)=>{this.setState({can_enter_newcase:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      <FormItem name="can_edit_case" label="can_edit_case" >
                          <Switch
                              checked={this.state.can_edit_case}
                              onChange={(val)=>{this.setState({can_edit_case:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>


                      <FormItem name="can_view_allcases" label="can_view_allcases" >
                          <Switch
                              checked={this.state.can_view_allcases}
                              onChange={(val)=>{this.setState({can_view_allcases:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      {/*new rights */}
             

                      <FormItem name="can_assign_cases" label="can_assign_cases" >
                          <Switch
                              checked={this.state.can_assign_cases}
                              onChange={(val)=>{this.setState({can_assign_cases:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      <FormItem name="can_create_case_review" label="can_create_case_review" >
                          <Switch
                              checked={this.state.can_create_case_review}
                              onChange={(val)=>{this.setState({can_create_case_review:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      <FormItem name="can_view_case_reviews" label="can_view_case_reviews" >
                          <Switch
                              checked={this.state.can_view_case_reviews}
                              onChange={(val)=>{this.setState({can_view_case_reviews:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>
                      
                       {/*new rights */}


                      <FormItem name="can_create_patient_reviews" label="can_create_patient_reviews" >
                          <Switch
                              checked={this.state.can_create_patient_reviews}
                              onChange={(val)=>{this.setState({can_create_patient_reviews:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      <FormItem name="can_edit_patient_reviews" label="can_edit_patient_reviews" >
                          <Switch
                              checked={this.state.can_edit_patient_reviews}
                              onChange={(val)=>{this.setState({can_edit_patient_reviews:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>

                      <FormItem name="can_view_patient_reviews" label="can_view_patient_reviews" >
                          <Switch
                              checked={this.state.can_view_patient_reviews}
                              onChange={(val)=>{this.setState({can_view_patient_reviews:val})}}
                              checkedChildren="ON"
                              unCheckedChildren="OFF"
                              />
                      </FormItem>



                        <FormItem>
                          <Button htmlType="submit" type="primary">Update</Button>
                        </FormItem>
                        
                      </Form>

              </Drawer>


              <Modal              
                visible={this.state.showpasswordupdatemodal}
                title="Password change Form"
                width={600}
                onCancel={this.closepasswordupdatemodal}

                footer={[
                  <Button key="back" onClick={this.closepasswordupdatemodal}>
                    Cancel
                  </Button>
                  ]}
                  >
              <Form
              onFinish={this.handlePasswordChange}        
              name="passwordreset"
              className="login-form">
        
              <Form.Item
                  name="new_password1"
                  label="New Password one"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your password!',
                    },
                  ]}
                  hasFeedback
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password one"
                  />


                </Form.Item>

          
                <Form.Item
                  name="new_password2"
                  label="Confirm New Password"
                  dependencies={['new_password1']}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: 'Please confirm your password!',
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (!value || getFieldValue('new_password1') === value) {
                          return Promise.resolve();
                        }
          
                        return Promise.reject('The two passwords that you entered do not match!');
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Confirm" />

                </Form.Item>

              <Form.Item >
                  <Button type="primary" htmlType="submit" className="login-form-button">
                    Confirm Change
                  </Button>
              </Form.Item>
            </Form>
                    
            </Modal>
        </div>
    )
    }
   
  }
}

export default AccountList; 
